<template>
    <div>
        <div class="content-header row">
        </div>
        <div class="content-body">                  
            <div class="row" v-if="userRole != 'user'">
                <div class="col-xl-4 col-lg-6 col-xs-12">                  
                    <div class="card">
                        <div class="card-content">
                        <div class="card-body">
                            <div class="media">
                                <div class="media-body text-left">
                                    <h3 class="info">{{stats.activeTenders}}</h3>
                                    <span>{{ $t('dashbord.countOfTender') }}</span>
                                </div>
                                <div class="media-right media-middle">
                                    <i class="icon icon-files-empty info font-large-2 float-right"></i>
                                </div>
                            </div>
                            <div class="progress mt-1 mb-0" style="height: 7px;">
                                <div class="progress-bar bg-info" role="progressbar" :style="calculatewidth(stats.activeTenders)"  aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                    </div>
                     </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-xs-12">                  
                    <div class="card">
                        <div class="card-content">
                        <div class="card-body">
                            <div class="media">
                                <div class="media-body text-left">
                                    <h3 class="deep-orange">{{stats.myTenders}}</h3>
                                    <span v-if="userRole == 'client'">{{ $t('dashbord.takePart') }}</span>
                                    <span v-if="userRole == 'admin'">{{ $t('dashbord.RateCount') }}</span>
                                </div>
                                <div class="media-right media-middle">
                                    <i class="icon icon-clipboard2 deep-orange font-large-2 float-right"></i>
                                </div>
                            </div>
                            <div class="progress mt-1 mb-0" style="height: 7px;">
                                <div class="progress-bar bg-deep-orange" role="progressbar" :style="calculatewidth(stats.myTenders)" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                    </div>
                     </div>
                </div>
                <div class="col-xl-4 col-lg-6 col-xs-12">                   
                    <div class="card">
                        <div class="card-content">
                        <div class="card-body">
                            <div class="media">
                                <div class="media-body text-left">
                                    <h3 class="success">{{stats.myWinTenders}}</h3>
                                    <span v-if="userRole == 'client'">{{ $t('dashbord.winsTender') }}</span>
                                    <span v-if="userRole == 'admin'">{{ $t('dashbord.ClosedTender') }}</span>
                                </div>
                                <div class="media-right media-middle">
                                    <i class="icon icon-trophy success font-large-2 float-right"></i>
                                </div>
                            </div>
                            <div class="progress mt-1 mb-0" style="height: 7px;">
                                <div class="progress-bar bg-success" role="progressbar" :style="calculatewidth(stats.myWinTenders)" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
                    

            </div>
            <!-- start user row -->
            <div class="row">
                <div class="card mx-1" v-if="userRole == 'user'">
                    <div class="card-content">
                        <div class="card-body">
                            <h3>{{$t('titles.my_deliveries')}}</h3>
                            <!-- ___________main-tables    -->                   
                            <div class="main-tables mobileTbl table-responsive p-1 outer" v-if="result">
                                    <table class="table table-hover mb-0 loading" cellspacing="0" >
                                        <thead>
                                            <tr>     
                                                <th style="vertical-align: middle;">{{ $t('table.order')}}</th>                                                           
                                                <th style="vertical-align: middle;">{{ $t('table.direction')}}</th>
                                                <th style="vertical-align: middle;">{{ $t('table.expected-delivery-date')}}</th>
                                                <!-- <th style="vertical-align: middle;"></th> -->
                                                <th style="vertical-align: middle;">{{ $t('table.on-map')}}</th>
                                                
                                                <!-- <th style="vertical-align: middle;">{{ $t('table.comments')}}</th>                         -->
                                            </tr>
                                        </thead>                                                       
                                        <tbody>                              
                                            <tr class="marginTR" v-for="(item) in result" :key="item.number">                                            
                                                <td :data-title="$t('table.order')"> <span class="action-icon link" >{{item.order}}</span></td>                                            
                                                <td :data-title="$t('table.status')"> {{item.paragraph}}</td>                                            
                                                <td :data-title="$t('table.direction')"> {{item.expectedDeliveryDate}}<span  class="action-icon " @click="showTransportDetail(item)"></span></td>     
                                                <!-- <td><a href="" ></a><font-awesome-icon icon="info" class="cursor"  @click="goToRef(item)"/> </td>                                         -->
                                                <td :data-title="$t('table.on-map')"><a href="#"  class="btn btn-primary" v-on:click="showModalMap(item.order)">{{ $t('label.display')}}</a></td> 
                                                <!-- <td :data-title="$t('table.comments')"> 
                                                <input type="text"
                                                    name="comment"
                                                    v-model="item.comment"
                                                    @change="changeComment(item.tc, item.comment)"
                                                    class="form-control" />
                                                
                                                </td>                                             -->                                                                 
                                            </tr>   
                                        </tbody>
                                    </table>
                                    <button class="btn btn-success  mb-2 mt-1 nextpage"  @click="gotoOrderList()">{{$t('titles.readmore')}}</button>
                            </div>
                            <!-- ____________________and main tables -->

                                        </div>
                    </div>
                </div>
                    
            </div>
            <!-- and user row -->
            <div class="row card map" v-if="userRole != 'user'" >              

                <div class="col-md-6" >
                       <!-- ______________________________________main-tables    -->
                       <h3>{{$t('dashbord.newTender')}}</h3>
                        <div class="main-tables mobileTbl table-responsive" >
                                <table class="table table-hover mb-0 loading" cellspacing="0" >
                                    <thead>
                                        <tr>     
                                            <th style="vertical-align: middle;">{{ $t('tender.table.number') }}</th>                                                           
                                            <th style="vertical-align: middle;">{{ $t('tender.table.downloadAdress') }}</th>                                           
                                            <th style="vertical-align: middle;">{{ $t('tender.table.deliveryAdress') }}</th>                                         
                                            <th style="vertical-align: middle;">{{ $t('tender.table.price') }}</th>                                         
                                            <!-- <th style="vertical-align: middle;"></th>                         -->
                                        </tr>
                                    </thead>                                                       
                                    <tbody>                              
                                        <tr class="marginTR" v-for="(item,index) in lastvins" :key="index"> 
                                            <td :data-title="$t('tender.table.number')">{{item.number}}  </td>                                                                                  
                                            <td  :data-title="$t('tender.table.downloadAdress')">{{item.loadingAdress}}</td>                                          
                                            <td  :data-title="$t('tender.table.deliveryAdress')">{{item.deliveryAdress}}</td>
                                          
                                            <td  :data-title="$t('tender.table.price')">{{item.rate}}&nbsp;{{item.currency}}</td>
                                            <!-- <td>
                                                <span @click="locate(item)"><i class="link icon-location2"></i></span>
                                                </td> -->
                                        </tr>   
                                    </tbody>
                                </table>
                                <button class="btn btn-success  mb-2 mt-1 nextpage"  @click="gotoTenderList()">{{$t('dashbord.toTenderList')}}</button>



                        </div>
                        <!-- ____________________and main tables -->

                </div>
                <div class="col-md-6">
                    <div id="gmap">
                <GmapMap
                    :center="{lat:48.978013, lng:29.5459663, z:8.25}"
                    :zoom="5"
                    map-type-id="terrain"
                    style="width: 100%; height: 600px;"
                    >
                    <GmapMarker
                        :key="index"
                        v-for="(m, index) in getMarkers()"
                        :position="m.position"
                        :clickable="true"
                        :draggable="true"  
                        :icon="getMarkerColor(m)"                                            
                        @click="toggleInfoWindow(m,index)"
                    />
                    <gmap-info-window 
                    :options="infoOptions" 
                    :position="infoWindowPos" 
                    :opened="infoWinOpen" 
                    @closeclick="infoWinOpen= !infoWinOpen"                    
                    >
                    <div v-html="infoContent"></div>
                     </gmap-info-window>

                    <!-- <gmap-marker :key="i" v-for="(m,i) in markers" :position="m.position" :clickable="true" @click="toggleInfoWindow(m,i)"></gmap-marker> -->
                   
                </GmapMap>
                    </div>
                </div>
                
            </div>           
           
        <!--/ stats -->
        </div>
         <!-- Modal -->
          <vue-modal :on-close="closeModalMap"
                   name="map-modal">
            <h3 slot="header" style="text-align:center">{{ $t('label.transport-location')}}</h3>
            <div class="row row-map">
                <GmapMap
                        :center="center"
                        :zoom="11"
                        map-type-id="terrain"
                        style="height: 600px">
                    <GmapMarker
                            :key="index"
                            v-for="(m, index) in list"
                            :position="m"
                            :clickable="true"
                            :draggable="true"
                    />
                </GmapMap>
            </div>
            <br/>
            <div class="row">
                <div class="col-md-12 mb-3">
                </div>
            </div>
        </vue-modal>
    <!-- And Modal -->
    </div>
</template>

<script>
import dayjs from 'dayjs';
  export default {
    name: "Dashboard",
    data(){
      return{        
        tender:{
        },
        result: null,
        report: {
            dataFrom: "",
            dataTo: "",
            numberOrder: null,
            frontoffice: null
        },
        list: [],
        center: { lat: 50.761871, lng: 25.3562243 },
      
        stats:{},
        location:[
            { lat: 50.4044734, lng: 30.825746 ,infoText:"marker1"},
          { lat: 50.6908899, lng: 25.3070401,infoText:"marker2" },
          { lat: 50.7416865, lng: 25.3847764,infoText:"marker3" },
        ],  
        testText:"sametext",
        tempMarkers:null,
        infoContent:null,
        lastvins:[],        
        infoWindowPos: null,
        infoWinOpen: false,
        currentMidx: null,
        infoOptions: {
        	content: '10',
            //optional: offset infowindow so it visually sits nicely on top of our marker
            pixelOffset: {
              width: 0,
              height: -35
            }
          },
        markers: [{
            position: {
              lat: 47.376332,
              lng: 8.547511
            },
            infoText: '<strong>Marker 1</strong>'
          }, {
            position: {
              lat: 47.374592,
              lng: 8.548867
            },
            infoText: '<strong>Marker 2</strong>'
          }]
      }
    },
    methods: { 
         showModalMap: function (order) {
          this.getPositionCar(order)
          this.$modals.show("map-modal")
         },
          closeModalMap: function () {
          this.list = [];
           this.center = { lat: 50.761871, lng: 25.3562243 };
          this.$modals.hide("map-modal");
      },
    
      getPositionCar(order) {
        let dataRequest = {
        orders: order ,       
        guidClient: localStorage.getItem("guidClient")
        };
        this.makeQuery("/report/getpositioncar", {
          dataRequest: dataRequest,
          token: localStorage.getItem("user-token"),
        })
        .then(res => {
        this.list = [res.data];
        this.center = res.data;  
        // console.log("dd343333");
      //  addr = this.geocodedAddress();
        //console.log(addr);
      })
      .catch(e => {
          this.$noty.error("Помилка отримання координат з сервера. Спробуйте за декілька хвилин.")
          this.loading = false
      });
       },
         getReport() {
            let dataRequest = {      
                dataStart: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
                dataEnd: dayjs().format('YYYY-MM-DD'),  
                frontOffice: "",        
                guidClient: localStorage.getItem("guidClient"),
            };
            this.makeQuery("/report/gettransportapplication", {
                dataRequest: dataRequest,
                token: localStorage.getItem("user-token"),
            })
                .then((res) => {
                this.result = res.data;                
                })
                .catch((err) => console.error(err));
    },
        getLabel(e){
            console.log(e)
            return e.number;
        },
        gotoTenderList(){
            this.$router.push({ name: 'transport_tender'});
        },
        gotoOrderList(){
            this.$router.push({ name: 'transport_request'});
        },
        locate(item){
            console.log(item);
        },
        calculatewidth(value){
            return `width: ${value}%`
        },
        remMarkers(){
            this.location.splice(1,1);
        }, 
         toggleInfoWindow: function(marker, idx) {
            this.infoWindowPos = marker.position;
            this.infoContent = this.getInfoWindowContent(marker);
            this.infoOptions.content = this.getInfoWindowContent(marker);

            //check if its the same marker that was selected if yes toggle
            if (this.currentMidx == idx) {
              this.infoWinOpen = !this.infoWinOpen;
            }

            //if different marker set infowindow to open and reset current marker index
            else {
              this.infoWinOpen = true;
              this.currentMidx = idx;
            }
          } ,    
        getStat(){                            
                let dataRequest = {userGuid: this.$store.state.guidClient};              
                this.makeQuery("/portal/dashboard", {dataRequest : dataRequest, token: this.$store.state.userToken })
                .then(res => {
                    if(res.data.result){ 
                       this.stats = res.data.data.indicators 
                       this.location =  res.data.data.location
                       this.lastvins =  res.data.data.listTenders
                    //    console.log(res.data.data);
                    }
                });           
        },
        getInfoWindowContent: function (marker) {
        let number = this.$t('tender.table.number');          
        let driver = this.$t('tender.table.driver');          
        let car = this.$t('tender.table.car');          
        let listOrder = this.$t('table.order');          
        let dateReceivedLocation = this.$t('tender.table.dateReceivedLocation');          
        let address = this.$t('tasks.table.address');      
        let res = `<span>${number} : ${marker.number}</span> <br/>
        <span>${listOrder} : ${marker.listOrder}</span> <br/>
        <span>${driver} : ${marker.driver}</span><br/>
        <span>${car} : ${marker.car}</span><br/>
         `
        return res;
        },
         getMarkers() {     
        var markers = [];        
       for(let i=0;i<this.location.length;i++){
           if(this.location[i].latitude && this.location[i].latitude != 0){ 
            //    console.log(this.location[i].longitude  )       
          markers.push({
              position:{
                lat: +this.location[i].latitude,
                lng: +this.location[i].longitude
            },
            infoText: this.location[i].driver ,
            driver: this.location[i].driver , 
            adress: this.location[i].address, 
            dateReceivedLocation:this.location[i].dateReceivedLocation,                 
            number:this.location[i].number,
            listOrder:this.location[i].listOrder, 
            type:this.location[i].type,                         
            car:this.location[i].car,                         
            }
            );
            }
        }
        this.tempMarkers =   markers; 
        return markers;  
          
    },
    getMarkerColor(marker){       
        return marker.type == 1 ? "https://maps.google.com/mapfiles/ms/icons/green-dot.png" : "https://maps.google.com/mapfiles/ms/icons/red-dot.png";   
         },

    },
    computed:{  
         userRole(){
            if(this.$store.getters.getUserRoleAdmin || this.$store.getters.getUserRoleLogist){
                return  "admin"    
            }
            else return "client"
           
        },        
      userRole(){
        if(this.$store.getters.getUserRoleAdmin){
            return  "admin"    
        }
        else if (this.$store.getters.getUserRoleLogist) {             
          return "logist"
        }
        else if (this.$store.getters.getUserRoleClient) {             
          return "client"
        }
        else return "user"      
      },
      
    },
    created() {},
    mounted(){        
        this.checkAuthorized();  
       this.getStat();
        if (this.userRole == 'user'){this.getReport();}
     
        
        
    }
  }
</script>

<style >
.link {
    cursor: pointer;
}
.lint :hover {
    color: rgba(44, 44, 49, 0.911);  
}
.nextpage {
    float: right;
}
.nextpage a:hover {
color: rgba(44, 44, 49, 0.911);    
}
.map {
    padding: 10px 10px;
    margin-left: 5px;
    margin-right: 5px;
}
.progress{
    display: flex;
    height: 1rem;
    font-size: .75rem;
    background-color: #EEE;
    border-radius: .21rem;
}

.card-body {
    -webkit-box-flex: 1;
    flex: 1 1 auto;
    padding: 1.5rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard.vue